export default "/_next/static/images/service-petted-desktop-3x-9ba7f1111e24e27695249c2f9aae992f.jpg";